module.exports = __webpack_public_path__ + "static/dinosaur_right-7a8359be52a77bd314e6ca8d097721e0.png";